
import { FullFTLOrderT } from '@/core/types/orders.types'
import { computed, defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        ftlOrder: {
            type: Object as PropType<FullFTLOrderT>,
            default: null,
        },
        isFirst: {
            type: Boolean,
            default: false,
        },
        isSecond: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const formatAmount = (amount: string | number | null) => {
            if (amount) {
                return `${amount.toLocaleString('ru-RU')} ₸`
            }

            return '-'
        }

        const isIntracity = computed(() => {
            return Boolean(props.ftlOrder && props.ftlOrder.ftl_type === 2)
        })

        const paymentRateTypeFirst = computed(() => {
            return props.ftlOrder &&
                props.ftlOrder.cost_price_info &&
                props.ftlOrder.cost_price_info.payment_rate_type
                ? 'за ' + props.ftlOrder.cost_price_info.payment_rate_type.toString().toLowerCase()
                : ''
        })

        const paymentRateTypeSecond = computed(() => {
            return isIntracity.value ? 'за час' : 'за рейс'
        })

        return {
            formatAmount,
            paymentRateTypeFirst,
            paymentRateTypeSecond,
        }
    },
})
